import {logUnreachableCode} from "@khan/logging";

import type {SortByType} from "../types.ts";

const SORT_RECENT = 2;
const SORT_TOP_VOTED = 1;
const SORT_TRENDING = 5;

export type GqlSortEnum =
    | typeof SORT_RECENT
    | typeof SORT_TOP_VOTED
    | typeof SORT_TRENDING;

/**
 * Converts from SortByType to associated enum value expected by the feedback resolver
 *
 * @param {string} sortType The sort type to be converted
 * @return {number} The enum value associated with the given sort type
 */
export const toGqlSortEnum = (sortType: SortByType): GqlSortEnum => {
    switch (sortType) {
        case "top-voted":
            return SORT_TOP_VOTED;
        case "recent":
            return SORT_RECENT;
        case "trending":
            return SORT_TRENDING;
        default:
            throw logUnreachableCode("Unexpected sort type provided", sortType);
    }
};
